import { render, staticRenderFns } from "./ecnnew.vue?vue&type=template&id=12786fe0&scoped=true&"
import script from "./ecnnew.vue?vue&type=script&lang=js&"
export * from "./ecnnew.vue?vue&type=script&lang=js&"
import style0 from "./ecnnew.vue?vue&type=style&index=0&id=12786fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12786fe0",
  null
  
)

export default component.exports